import styled from 'styled-components';
import theme from '../../styles/theme';

export const HeaderMainWrap = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: ${props => (props.showBanner ? theme.layout.topBanner : 0)};
  width: 100%;
  max-width: ${theme.layout.maxWidth};
  height: 60px;
  padding: 0 20px;
  background: ${theme.backgroundColor.white};
  border-bottom: ${props => (props.onlyLogo ? '1px solid #d0d0d0' : 'none')};
  z-index: 35;
  @media screen and (max-width: 375px) {
    padding: 0 10px;
  }
  h1 {
    width: 174px;
    line-height: 0;
    cursor: pointer;

    @media screen and (max-width: 375px) {
      width: 145px;
    }
    img {
      width: 100%;
    }
  }

  & > div {
    display: flex;
    align-items: center;
    gap: 15px;
    z-index: 1;
    @media screen and (max-width: 375px) {
      gap: 8px;
    }
  }
  button {
    all: unset;
    cursor: pointer;
    &.btnLoan {
      font-size: 1.5rem;
      font-weight: 700;
    }
  }
`;

export const HeaderSubWrap = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: ${props => (props.showBanner ? theme.layout.topBanner : 0)};
  width: 100%;
  max-width: ${theme.layout.maxWidth};
  height: 60px;
  padding: 0 20px;
  background: ${theme.backgroundColor.white};
  border-bottom: 1px solid ${theme.borderColor.lightGrey};
  z-index: 35;
  @media screen and (max-width: 375px) {
    padding: 0 10px;
  }

  & > div {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
    @media screen and (max-width: 375px) {
      gap: 4px;
    }
  }
  button {
    all: unset;
    cursor: pointer;
  }

  h2 {
    position: absolute;
    left: 0;
    width: 100%;
    text-align: center;
    letter-spacing: -0.1px;
    font-size: 1.8rem;
    font-weight: 600;
    z-index: 0;
    @media screen and (max-width: 375px) {
      letter-spacing: -0.2px;
      font-size: 1.6rem;
    }
  }
`;

export const HeaderLogoWrap = styled.header`
  position: fixed;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: ${theme.layout.maxWidth};
  height: 60px;
  padding: 0 20px;
  background: ${theme.backgroundColor.white};
  border-bottom: 1px solid ${theme.borderColor.lightGrey};
  z-index: 35;

  h1 {
    width: 174px;
    line-height: 0;
    cursor: pointer;

    @media screen and (max-width: 375px) {
      width: 145px;
    }
    img {
      width: 100%;
    }
  }
`;
